import React from 'react';
import { LayoutDashboard, Kanban, Calculator, TrendingUp } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface MobileNavProps {
  activeView: 'calculator' | 'dashboard' | 'pipeline' | 'forecast';
  onViewChange: (view: 'calculator' | 'dashboard' | 'pipeline' | 'forecast') => void;
}

export default function MobileNav({ activeView, onViewChange }: MobileNavProps) {
  const { profile } = useAuth();
  const isAdmin = profile?.role === 'admin';

  const navItems = [
    { id: 'dashboard' as const, label: 'Dashboard', icon: LayoutDashboard, adminOnly: true },
    { id: 'pipeline' as const, label: 'Pipeline', icon: Kanban, adminOnly: false },
    { id: 'calculator' as const, label: 'Calculator', icon: Calculator, adminOnly: false },
    { id: 'forecast' as const, label: 'Forecast', icon: TrendingUp, adminOnly: true },
  ].filter(item => !item.adminOnly || isAdmin);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 md:hidden safe-area-inset-bottom">
      <div className="flex items-center justify-around px-2 py-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeView === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className={`flex flex-col items-center justify-center flex-1 py-2 px-1 rounded-lg transition-all min-w-0 ${
                isActive
                  ? 'text-blue-600'
                  : 'text-gray-500 active:bg-gray-100'
              }`}
              aria-label={item.label}
            >
              <Icon className={`w-6 h-6 mb-1 ${isActive ? 'stroke-[2.5]' : 'stroke-2'}`} />
              <span className={`text-xs font-medium truncate w-full text-center ${
                isActive ? 'font-semibold' : ''
              }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
